import {useLocation} from "react-router-dom";
import {useAppSelector} from "../store/hooks";
import {selectReleaseToggles} from "../ReleaseToggles/releaseTogglesSlice";
import segmentAnalytics from "src/utils/segmentAnalytics";
import {selectActiveMeeting} from "../ClientManagement/Meeting/meetingSlice";
import {MeetingStatus} from "../ClientManagement/Meeting/Meeting";
import {App_Conf} from "../core/app_conf";
import {selectProfile} from "../ClientManagement/ClientProfile/activeProfileSlice";
import {selectIsReportingCall} from "../Reporting/CreateReport/ReportingSlice";

export function useAnalyticsTrackers(featureFlag?: string) {
    const releaseToggles: any = useAppSelector(selectReleaseToggles);
    const selectedProfile = useAppSelector(selectProfile);

    const isReportingCall: boolean = useAppSelector(selectIsReportingCall);

    const location = useLocation();
    const {GOOGLE_ANALYTICS_ENV} = App_Conf;

    const path = (location.pathname || '')
        .split('/')
        .filter(Boolean)
        .pop() || '';

    const activeMeeting = useAppSelector(selectActiveMeeting);
    const isMeetingOngoing = activeMeeting?.status === MeetingStatus.STARTED || activeMeeting?.status === MeetingStatus.CREATED;

    const originalData = {
        cd4_duration: 0,
        cd8_prTargetYears: 0,
        cd7_minimumRiskYears: 0,
        cd13_gst_tag: 0,
        cd12_meeting_id: 0,
    }

    let releaseFlag: any = 'enableGoogleAnalytics';

    switch (true) {
        case location.pathname?.includes('/EstateFlowchart'):
            releaseFlag = 'enableDEFGoogleAnalytics';
            break;
        case location.pathname?.includes('/Agenda'):
            releaseFlag = 'enableAgendaGoogleAnalytics';
            break;
        case location.pathname?.includes('/Goals'):
            releaseFlag = 'enableGoalsGoogleAnalytics';
            break;
        case location.pathname?.includes('/AssetTitling'):
            releaseFlag = 'enableAssetTitlingGoogleAnalytics';
            break;
        case location.pathname?.includes('/Funding'):
            releaseFlag = 'enableGoogleAnalyticsInGFOT';
            break;
        case location.pathname?.includes('/AssetAllocation'):
            releaseFlag = 'enableCurrentVsProposedGoogleAnalytics';
            break;
        case location.pathname?.includes('/WealthTransferPlanning/Edit/Beneficiaries'):
            releaseFlag = 'enableGAWealthTransferEditBeneficiaries';
            break;
        case location.pathname?.includes('/WealthTransferPlanning'):
            releaseFlag = 'enableGoogleAnalyticsWealthTransfer';
            break;
        default:
            releaseFlag = featureFlag ?? 'enableGoogleAnalytics';
    }

    const page = (eventName: string, eventData: Record<string, any> = {}) => {
        const title = path || "Unknown Component";
        if (releaseToggles?.[releaseFlag] && eventName != null && isReportingCall === false) {
            segmentAnalytics.page({
                properties: {
                    ...originalData,
                    env: GOOGLE_ANALYTICS_ENV,
                    experience: "GDWM",
                    cd1_event_title: title,
                    cd2_event_details: "gaTrackEvent_" + eventName,
                    cd3_inMeeting: isMeetingOngoing ? "true" : "false",
                    cd12_meeting_id: activeMeeting?.id ?? 0,
                    cd14_gpsio_flag: selectedProfile.gpsIOFlag ?? "N",
                    ...eventData
                }
            });
        }
    };

    const track = (eventName: string, eventData: Record<string, any> = {}) => {
        const title = path || "Unknown Component";
        if (releaseToggles?.[releaseFlag] && eventName != null && isReportingCall === false) {
            segmentAnalytics.track(eventName, {
                properties: {
                    ...eventData,
                    env: GOOGLE_ANALYTICS_ENV,
                    experience: "GDWM",
                    cd1_event_title: title,
                    cd2_event_details: "gaTrackEvent_" + eventName,
                    cd3_inMeeting: isMeetingOngoing ? "true" : "false",
                    cd14_gpsio_flag: selectedProfile.gpsIOFlag
                }
            });
        }
    };

    return {track, page};
}